import { Add } from "@mui/icons-material";
import { Button, Divider, Grid, Pagination, Stack, Slide, Snackbar, Alert, Paper } from "@mui/material";
import { Container } from "@mui/system";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { variables } from "../../styles/abstract/variables";
import { DataContext } from "../DataContext";
import BackgroundWidget from "../widgets/BackgroundWidget";
import WidgetDescription from "../widgets/WidgetDescription";
import WidgetTitle from "../widgets/WidgetTitle";
import CreateProject from "./CreateProject";
import EditProject from "./EditProject";
import DeleteProject from "./DeleteProject";
import ProjectBox from "./ProjectBox";
import ReportsModal from "./ReportsModal";
import { AppContext } from "../../AppContext";

function Projects(props) {
	const { selected, onUpdateState } = useContext(AppContext)
	const { projects, page, onSetPage } = useContext(DataContext);

	const [create, setCreate] = useState(false);
	const [edit, setEdit] = useState(false);
	const [remove, setRemove] = useState(false);

	const [reportsModal, setReportsModal] = useState(null);

	const renderProjects = () => {

		return projects.results.map((project, key) => {
			return <Grid key={key} item xs={12} sm={12} md={6} lg={4}>
				<ProjectBox onSelectProject={() => { onUpdateState({ selected: project.id }) }} project={project} edit={edit} onToggleReports={setReportsModal} onToggleEdit={setEdit} onToggleRemove={setRemove} remove={remove} />
			</Grid>
		})
	}

	const renderContent = () => {
		if (projects.count === 0) {
			return (
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Stack component={Paper} elevation={3} sx={{ padding: '10px' }} className="only-laptop co-background" direction="row" alignItems="center" justifyContent="space-between">
							<WidgetTitle text="My Farms" />
						</Stack>
					</Grid>
					<Grid item xs={12}>
						<Divider color="primary" light style={{ background: variables.primary, height: '3px' }} />
					</Grid>
					<Grid item xs={12} textAlign={'center'}>
						<Stack component={Paper} elevation={3} sx={{ padding: '10px' }} className="only-laptop co-background" direction="column" alignItems="center" justifyContent="center" spacing={2}>
							<WidgetDescription text="There are no farms created" />
							<Button color="info" onClick={() => setCreate(true)} sx={{ lineHeight: 'unset', color: '#fff' }} startIcon={<Add />} variant="contained">CREATE NEW FARM</Button>
						</Stack>
					</Grid>
					<Grid item xs={12} textAlign={'center'}>
					</Grid>
				</Grid>
			);
		}

		return (
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Stack component={Paper} elevation={3} sx={{ padding: '10px' }} className="only-laptop co-background" direction="row" alignItems="center" justifyContent="space-between">
						<WidgetTitle text="My Farms" />
						<Button color="info" onClick={() => setCreate(true)} sx={{ lineHeight: 'unset', color: '#fff' }} startIcon={<Add />} variant="contained">CREATE NEW FARM</Button>
					</Stack>

					<Stack component={Paper} elevation={3} sx={{ padding: '10px' }} className="only-mobile co-background" direction="column">
						<WidgetTitle text="My Farms" />
						<Button color="info" onClick={() => setCreate(true)} sx={{ lineHeight: 'unset', color: '#fff' }} startIcon={<Add />} variant="contained">CREATE NEW FARM</Button>
					</Stack>
				</Grid>

				<Grid item xs={12}>
					<Divider color="primary" light style={{ background: variables.primary, height: '3px' }} />
				</Grid>
				{projects.count >= 10 && <Grid item xs={12}>
					<Pagination count={Math.floor(projects.count / 10)} page={page + 1} siblingCount={0} color="secondary" sx={{ '& li>button, & li>div': { color: variables.secondary }, '& li>button[aria-current=true]': { color: variables.primary, fontWeight: 'bold' } }} ></Pagination>
				</Grid>}
				<Grid item xs={12}>
					<Grid container spacing={2}>
						{renderProjects()}
					</Grid>
				</Grid>
			</Grid>
		);
	}
	return (
		<>
			<Container style={{ marginTop: '30px', marginBottom: '30px' }}>
				{renderContent()}
			</Container>

			{Boolean(create) && <CreateProject open={create} onClose={() => setCreate(false)} />}
			{Boolean(edit) && <EditProject open={Boolean(edit)} project={edit} onClose={() => setEdit(false)} />}
			{Boolean(remove) && <DeleteProject open={Boolean(remove)} project={remove} onClose={() => setRemove(false)} />}

			<ReportsModal open={Boolean(reportsModal)} model={reportsModal} onClose={() => setReportsModal(null)} />
		</>
	)
}

export default Projects;